import { Component, Input, OnChanges, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';


// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { delay, Observable, retry } from 'rxjs';
import { MyobServiceInvoice } from './../../..//models/myob-service-invoice.model';
import { SubjectInvoiceItem } from './../../..//shared/models/subjectInvoiceItem.model';
import { SubjectInvoice } from './../../..//shared/models/subjectInvoice.model';
import { Brand } from './../../..//shared/models/brand.model';
import { Payment } from './../../..//shared/models/payment.model';
import { MyobServicePaymentInvoice } from './../../..//models/myob-service-invoice-payment.model';

import { MyobApiInvoiceSyncToolsWidgetComponent } from './../../../components/myob/myob-api-invoice-sync-tools-widget/myob-api-invoice-sync-tools-widget.component'
import { Job } from './../../../shared/models/job.model';

@Component({
  selector: 'app-myob-api-invoice-payment-sync-tools-widget',
  templateUrl: './myob-api-invoice-payment-sync-tools-widget.component.html',
  styleUrls: ['./myob-api-invoice-payment-sync-tools-widget.component.css']
})
export class MyobApiInvoicePaymentSyncToolsWidgetComponent implements OnInit, OnChanges {



  @Input() sent_data?: any; // not used
       // setup as observable?
       @Input() item_id?: Observable<any[]>; // impliments on changes.
      //  @Input() invoice_id?; // impliments on changes.
       @Input() payment_id?: Observable<any[]>;// impliments on changes.
      //  @Input() item_id?: Observable<any[]>; // impliments on changes.
       @Input() invoice_id?: Observable<any[]>; // impliments on changes.
       @Input() UID?: Observable<any[]>; // impliments on changes.

       @Input() brand_id?: Observable<any[]>; // impliments on changes.
       @Input() subject_id?; // impliments on changes.

       @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
       @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
       @Input() item_user_level_id? = '5'; // default to agent just in case
       @Input() item_brand_type_id? = '';
       @Input() show_buttons? = 'no'; // yes | no
       @Input() widget_title? = '';
       @Input() widget_size? = ''; // side | abstract | full | check

       @Input() job_id?
       @Input() subject_number?
       @Input() job_number?
       @Input() DisplayID?;

       job: Job; // Job Model

    sessionUserId: any;
    sessionUsername: any;
    sessionBrandId: any;
    all_router_details: string;
  
// Grid Vars
public data: DataManager;
public data_subjects: DataManager;
public pageSettings: Object;
public pageOptions = { pageSize: 100 }; 
public filterOptions: FilterSettingsModel;
public formatOptions: Object;
// public filterOptions: FilterSettingsModel;
public filter : IFilter;
public toolbarOptions: ToolbarItems[];
@ViewChild('grid')
public grid: GridComponent;
public groupOptions: GroupSettingsModel;
public templateOptionsDate: IFilterUI;
public elem1: HTMLElement;
public datePickerObj: DatePicker;
subjects_urgent: any;
formatoptions: { type: string; format: string; };
dateFormat: string;
sortOptions: { columns: { field: string; direction: string; }[]; };

today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
// today_set = new Date(); // sets todays date
// today = this.datepipe.transform(this.today_set, 'dd/MM/yyyy h:mm a'); // formats date for comparison

initialPage: { pageSize: number; };
 invoices: any;
 modalRef: any;
 myobInvoiceCreatedData: any;
 myobInvoiceListMapped: any;
 set_RowVersion: any;
 brand: any;
 brandData: any;
 data_invoice: any = MyobServiceInvoice;
 myobInvoices: Object;
 arrCase: object[];
 Items: any;
 myobInvoiceDeleteData: Object;
 myobInvoice: Object;
 invoiceItem: any;
 invoiceItemsList: any = SubjectInvoiceItem;
 
 myob_account_codes: Object;
 myob_tax_codes: Object;
 myobInvoiceUpdateData: any;
 myobInvoiceUpdatedData: any;

 invoice_model: SubjectInvoice = new SubjectInvoice();
 invoice_item_model: any = SubjectInvoiceItem;
 invoiceItemUpdateList: any;
 new_line: {};

 data_payment: any = MyobServicePaymentInvoice;
model: any;

payments: any;
paymentItemsList: any;
payment_item_model: any = SubjectInvoiceItem;
myobPaymentCreatedData: any;
myobPaymentListMapped: any;
myobPaymentDeletedData: Object;


  subject: Object;
  brand_invoice_id: any;
  invoice_job_type_id: any;
  invoice_brand: Object;
  owner_brand: Object;
  invoice_status: Object;
  invoice_status_name: any;
  invoice_status_var: any;
  invoice_payment_status: Object;
  invoice_payment_status_name: any;
  invoice_payment_status_var: any;
  invoice_communication_status: Object;
  invoice_communication_status_name: any;
  invoice_communication_status_var: any;
  invoice_status_all: Object;
  invoice_payment_status_all: Object;
  invoice_communication_status_all: Object;
  invoice_number: any;
  is_job_invoice_var: any;

  open_jobs_count: any;
  myobCustomers: Object;

  myobCustomerCreatedData: any;
  brand_types: any;
  users: any;
  usersPrimary: any;
  job_table_clients: any;
  btLocalRecord: any;
  changeObject: any;
  userLocalRecord: any;
  job_table_clients3: any;
  UID_new_customer: any;
  returned_update: Object;
  myobCustomerDeleteData: Object;
  myobCustomerUpdateData: Object;
  customerItem: any;
  myobContactListMapped: any;
  myobCustomer: Object;
  IsIndividual: any;
  brand_data: any;
  brand_data_item: any = Brand;
  payment_data: any;
  payment_data_item: any = Payment
  subject_id_check: any;
  retuned_payment_update: Object;
  subject_invoice: Object;
  current_invoice_UID: any;
  myob_checker: Object;
  myob_response;


  response_from_node: string;
  response_from_node_raw: any;
  error_message: any;
  error_name: any;
  full_response_data: any;
  data_sent: any;
  data_sent_id: any;
  data_sent_DisplayID: any;
  full_response_status: any;
  full_response_header
  full_response_headers: any;
  full_response: any;
  error_message_standard: any;
  data_sent_client_brand_id: any;
  data_sent_agent_brand_id: any;
  data_sent_invoice_id: any;
  data_sent_invoice_UID: any;
  data_sent_client_invoice_id: any;
  data_sent_agent_invoice_id: any;
  data_sent_invoice_payment_id: any;
  data_sent_work_order_payment_id: any;
  data_sent_work_order_id: any;
  data_sent_work_order_UID: any;
  data_sent_work_order_spending_id: any;

  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,  public gfunc: GlobalFunctionsService,
   public toastr: HotToastService,
   public myobApi_ITW: MyobApiInvoiceSyncToolsWidgetComponent,
  //  vcr: ViewContainerRef,
  ) { 
    // this.toastr.setRootViewContainerRef(vcr);


 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));

      // Grid Options
      this.toolbarOptions = ['Search'];
      this.initialPage = { pageSize: 40 };
      this.filterOptions = {
        type: 'Menu'
      };
      // this.groupOptions = { columns: ['job_id'] }; // sets auto grouping for the grid
      this.groupOptions = { }; // sets auto grouping for the grid
      this.formatoptions= {type:'date', format:'dd/MM/yyyy'};
      this.dateFormat = 'dd/MM/yyyy hh:mm a';
      // this.filter = { params: { format: this.dateFormat } };
      this.sortOptions = { columns: [{ field: 'name', direction: 'Ascending' } ] };

      // this.myob_response = true;
      // this.myobChecker();
  }



 // check for changes. to load data.
 ngOnChanges(changes) {

  if (changes.item_id) {
    // deal with asynchronous Observable result
    this.brand_id = changes.item_id.currentValue;
    this.UID = changes.UID.currentValue;
    // this.getJob(this.job_id);
  }
  if (changes.subject_id) {
  this.subject_id_check = changes.subject_id.currentValue; // setup so it can redirect if there is a subject id detected.
  this.subject_id = changes.subject_id.currentValue; // setup so it can redirect if there is a subject id detected.
  }

  if (changes.payment_id) {
    this.payment_id = changes.payment_id.currentValue;

this.getPayment(this.payment_id);
// this.getBrandBrandTypes();

   // load some myob stuff
   this.getMyobTaxCodes(); // load for merge variables arrays
   this.getMyobAccountCodes();
   this.getSubjectInvoice(this.invoice_id); // ge the invoice UID from observable. to load/refres inv vers after payment.
  }

  if (changes.invoice_id) {this.invoice_id = changes.invoice_id.currentValue; };



}




  ngOnInit() {
       // load some myob stuff

  }





  // :: Grid Functions


// https://ej2.syncfusion.com/angular/documentation/grid/tool-bar/#built-in-and-custom-items-in-toolbar
clickHandler(args: ClickEventArgs): void {
  if (args.item.id === 'Click') {

  //  this.grid.showSpinner();

  //    alert('This function will trigger the action to Emails, and Status Notifications to Agents');
 //  console.log(args.data.items);
 


  let pdfdata;
  const query = this.grid.renderModule.data.generateQuery(); // get grid corresponding query
  for (let i = 0; i < query.queries.length; i++) {
    if (query.queries[i].fn === 'onPage') {
      query.queries.splice(i, 1);       // remove page query to get all records
      break;
    }
  }
  const fdata = new DataManager({ json: this.subjects_urgent }).executeQuery(query).then((e: any) => {
    pdfdata = e.result as object[];  // get all filtered records
    const exportProperties = {
      dataSource: pdfdata,
    };
    // console.log(pdfdata.results);

   // this.search_results = pdfdata.records; // need this if a grouping is set.
  /*   this.search_results = pdfdata;
    this.toastr.info( this.search_results.length + ' subjects added to the update Request Que'); 
    this.toastr.success( "Press Start To Process Que");  */
   // this.grid.pdfExport(exportProperties);
  }).catch((e) => true);
  }

 //  this.grid.hideSpinner();

};


toolbarClick(args: ClickEventArgs): void {
  if (args.item.id === 'Grid_excelexport') { // 'Grid_excelexport' -> Grid component id + _ + toolbar item name
      this.grid.excelExport();
  }
}
rowDataBound(args: RowDataBoundEventArgs) {
  const job_status = 'job_status';
  if (args.data[job_status] === 'CLOSED') {
      args.row.className = 'strikethrough';
  }
}

  // :: Grid Functions


  getPayment(payment_id) {
    this._demoService.getPayment(payment_id).subscribe(
      (data) => {
        this.payment_data = data;
      },
      (err) => console.error(err),
      () => console.log('Brand Loaded.')
    );
  }



// Myob Functions


setMyobPaymentModelStep1W(model){
console.log('SendModel:: ' + JSON.stringify(model));
this.getMyobTaxCodes(); // load data arrays
this.getMyobAccountCodes(); // load data arrays
this.getInvoicePaymentsByPaymentIDStepW(model.payment_id, model);
};


// WRONG PAYMENT ITEMS?
 // Get Invoice Payment Items
 getInvoicePaymentsByPaymentIDStepW(payment_id, model){
  // this._demoService.getInvoicePaymentsByPaymentID(payment_id).subscribe( // maybe wrong?????
  this._demoService.getInvoicePaymentsByPaymentIDInvoiceID(payment_id, model.invoice_id).subscribe(   // upgraded so that gets correct payment (I commented out why in DW why>>>>>????)
    (data) => {
      this.paymentItemsList = data;
      // let res = data[0];
      this.payment_item_model = this.paymentItemsList;
      console.log('PaymentItemsList: [invoice-payments]' + JSON.stringify(this.payment_item_model));

           // New Step First Pull Row Version of INvoice and update. 
           console.log('Looking Up and updating Invoice + Items Row Versions etc......');
          //  this.myobApi_ITW.getMyobAccountCodes();
          //  this.myobApi_ITW.getMyobTaxCodes();
          //  this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.UID, model); // may not need now fixed below?
 

    },
    (err) => console.error(err),
   () => {
    //  console.log('.');
   /// moved this up /\
  this.setMyobPaymentModelStep2W(model, this.payment_item_model);
   }
   );
  };



 // :: Create Payment.
  setMyobPaymentModelStep2W(model, payment_item_model) {
// get the account code.

this.data_payment.Invoices = {}; //  empty the Invoice array every loop.

const paymentAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === model.myob_account_code_id ));
const setMaymentAccount = paymentAccountUID[0].myob_account_id;
                  this.data_payment = {
                    'PayFrom': 'Account',
                    'Account': {
                      'UID': setMaymentAccount
                    },
                    'Customer': {
                      'UID': model.CustomerUID
                    },
                    'PayeeAddress': '',
                    'StatementParticulars': '',
                    'PaymentNumber': '1',
                    'Date': model.payment_date,
                    'AmountPaid': model.payment_total,
                    'Memo': 'SOP Payment; ' + model.CustomerName + ' SPID:' + model.payment_id,
                    'Invoices': [
                    //   {
                    //   'UID': '49dd6a4b-5b99-479d-8022-094f336da2d7',
                    //   'AmountApplied': 46.2,
                    //   'Type': 'Invoice'
                    // }
                  ],
                    'DeliveryStatus': 'Print',
                    'ForeignCurrency': null
                  };
                   
                  
                  let new_line;
                       new_line = {
                        // 'UID': this.payment_item_model[0].UID,  // This corrected the wrong payments wrong invoices if the same. ! FIXED!
                        'UID': model.myob_id,  // has to be an invoice ID code  //// WRONG INVOICE ID ON SECOND ROUND LOOPS
                        // 'UID': res.myob_id,  // has to be an invoice ID code
                        'AmountApplied': model.invoice_total,
                        'Type': 'Invoice'
                    };

                 this.data_payment.Invoices.push(new_line);
                // this.data_payment.Invoices = {
                //   ...new_line
                // };

                //     this.data_payment.Invoices.push(new_line);
                   console.log('data_payment Model: [myob insert model]' + JSON.stringify(this.data_payment));
                  //  console.log('model.InvoiceUID: ' + model.UID); // is Invoice.UID
                   this.createMyobPaymentModelW(model, this.data_payment); // was throwing serialization errors in myob
                 }



                 createMyobPaymentModelW(model, data_payment){
                    this._demoService.createMyobPayment(this.data_payment).subscribe(
                    data => { this.myobPaymentCreatedData = data;
                      let res = data[0];
                      const new_data_object = JSON.parse(this.myobPaymentCreatedData);
                      const location_string = new_data_object.location;
                      // get everything after last dash function 
                      const slug: any = location_string.split('/').pop(); // 2020
                      console.log('UUID slug: ' + slug);




                      // Need to make this a proper function so I get a proper result.


                      this.MovedgetMyobPaymentsMapped(slug, model)

             

                                  // Now Update All invoices Paid.
                                  // Mow also need to pull and upate the invoice SINGLE Invoice detauls as a function.
                                  // let  count_of_items = this.payment_item_model.length;
                                  // invoice UID
                                  console.log('model.InvoiceUID: ' + model.UID); // current Items InvoiceUID
                                  // this.lookupInvoiceUpdateInvoice2W(model.UID, model);
                                  // this.myobApi_ITW.getMyobAccountCodes();
                                  // this.myobApi_ITW.getMyobTaxCodes();
                                
                                
                                
          // this.myobApi_ITW.getMyobAccountCodes();
          // this.myobApi_ITW.getMyobAccountCodes();
          // this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.UID, model); // THIS WORKS.

                        //          this.updatePaymentLast(model);  // updates the payment record. //1
                                  // this.toastr.info('Invoice Payments + Items Vrs Upgraded In SOP');
                                  // this.refreshGrid();
                         //         this.getPayment(model.payment_id); // just tring to regresh comppoentent after create

                                // set up a global redirect so that it refreshed if included on two levels down.
                                if (this.subject_id_check >= 1) {
                                // this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
                                }
                                },
                                err => {
                                  // this.toastr.error('You need to login to MYOB again, Connection lost!');
                                console.log(err.error);
                                },
                                // () => {
                                //   // console.log('done loading Trace Types');
                                //   }
                              );
     
                };




                MovedgetMyobPaymentsMapped(slug, model){
         // :: Need to lookup myoub get UID/myobid and fill rest of data for invoice updated .vars.
         this._demoService.getMyobPaymentsMapped(slug, model).subscribe(
          data4 => {
           console.log(data4);
          let res2 = data4[0];

         this.myobPaymentListMapped = data4;
         // Set the returned Variables Reququied for Update of a Myob Customer.
         // console.log('UID: ' +  data4.UID);
         // console.log('LastModified: ' + data4.LastModified);
         // console.log('RowVersion: ' + data4.RowVersion);
         this.set_RowVersion = data4.RowVersion;
       // All Additional Myon Invoice Payment Variables
         model.UID = data4.UID;
         model.DepositTo = data4.DepositTo;
         model.AccountUID = data4.Account.UID;
         model.CustomerUID = data4.Customer.UID;
         model.URI = data4.URI;
         model.myob_array = JSON.stringify(data4);
         model.RowVersion = data4.RowVersion;
         model.myob_id = slug;
         model.sync_with_myob = 1;


         // Now run the payment records

       // Now run the payment records
       console.log('End Payment Model: ' + JSON.stringify(model)); // current Payment Items to Update Paymet
       console.log('myobPaymentListMapped: ' + JSON.stringify(this.myobPaymentListMapped));
       console.log('Data4.UID: ' + data4.UID);
       this.updatePaymentLast(model);  // updates the payment record. //1

       },
       error => {
         // console.error('Error saving Event!');
         //  this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
         console.log(error.error);
        });
                }




   lookupInvoiceUpdateInvoice2W(UID, model){
              this._demoService.getMyobInvoiceMapped(UID, model).subscribe(
                data4 => {
                     console.log(data4);
                     let res = data4[0];
                     this.myobInvoiceListMapped = data4;
                   // Set the returned Variables Reququied for Update of a Myob Customer.
                  //  console.log('UID: ' +  data4.UID);
                  console.log('UID: ' +  data4.UID);
                  // console.log('retInvoiceModel: ' +  JSON.stringify(data4));

               const sent_invoice_id = UID;
              //  const sent_real_invoice_id = model.invoice_id;
              // this.invoice_model = {}; // clear the invoice moddl.

                // work out the nulls for sub arraryas
                let CategoryUID;
                let OrderUID;
                let SalespersonUID

                if (typeof model.Category === 'undefined' || model.Category === null ) {
                  CategoryUID = null;
                }else {
                  CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                };
                if (typeof model.Order === 'undefined' || model.Order === null ) {
                  OrderUID = null;
                }else {
                  OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                };
                if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                  SalespersonUID = null;
                }else {
                  SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                };

                  this.set_RowVersion = data4.RowVersion;
                  // Local data vars.
                  //  model.myob_array = JSON.stringify(data4);
                  //  model.myob_id = data4.UID;

                  //  model.UID = data4.UID;
                  //  model.Number = data4.Number;
                  //  model.Date = data4.Date;
                  //  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
                  //  model.CustomerUID = data4.Customer.UID;
                  //  model.CustomerName = data4.Customer.Name;
                  //  model.CustomerDisplayID = data4.Customer.DisplayID;
                  //  model.PromisedDate = data4.PromisedDate;
                  //  model.BalanceDueAmount = data4.BalanceDueAmount;
                  //  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
                  //  model.Status = data4.Status;
                  //  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
                  //  model.TermsDiscountDate = data4.Terms.DiscountDate;
                  //  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
                  //  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
                  //  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
                  //  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
                  //  model.TermsDiscount = data4.Terms.Discount;
                  //  model.TermsDueDate = data4.Terms.DueDate;
                  //  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
                  //  model.IsTaxInclusive = data4.IsTaxInclusive;
                  //  model.Subtotal = data4.Subtotal;
                  //  model.SubtotalForeign = data4.SubtotalForeign;
                  //  model.Freight = data4.Freight;
                  //  model.FreightForeign = data4.FreightForeign;
                  //  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
                  //  model.TotalTax = data4.TotalTax;
                  //  model.TotalTaxForeign = data4.TotalTaxForeign;
                  //  model.TotalAmount = data4.TotalAmount;
                  //  model.TotalAmountForeign = data4.TotalAmountForeign;
                  //  model.CategoryUID = CategoryUID; // var
                  //  model.SalespersonUID = SalespersonUID; // var
                  //  model.Comment = data4.Comment;
                  //  model.ShippingMethod = data4.ShippingMethod;
                  //  model.JournalMemo = data4.JournalMemo;
                  //  model.ReferralSource = data4.ReferralSource;
                  //  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
                  //  model.LastPaymentDate = data4.LastPaymentDate;
                  //  model.CanApplySurcharge = data4.CanApplySurcharge;
                  //  model.OrderUID = OrderUID; // var
                  //  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
                  //  model.ForeignCurrency = data4.ForeignCurrency;
                  //  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
                  //  model.LastModified = data4.LastModified;
                  //  model.URI = data4.URI;
                  //  model.RowVersion = data4.RowVersion;


              // make the function more universal? or make custom by itself?
                   this.invoice_model = {
                    myob_array: JSON.stringify(data4),
                    myob_id: data4.UID,
                    UID: data4.UID,
                    Number: data4.Number,
                    Date: data4.Date,
                    CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
                    CustomerUID: data4.Customer.UID,
                    CustomerName: data4.Customer.Name,
                    CustomerDisplayID: data4.Customer.DisplayID,
                    PromisedDate: data4.PromisedDate,
                    BalanceDueAmount: data4.BalanceDueAmount,
                    BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
                    Status: data4.Status,
                    TermsPaymentIsDue: data4.Terms.PaymentIsDue,
                    TermsDiscountDate: data4.Terms.DiscountDate,
                    TermsBalanceDueDate: data4.Terms.BalanceDueDate,
                    TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
                    TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
                    TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
                    TermsDiscount: data4.Terms.Discount,
                    TermsDueDate: data4.Terms.DueDate,
                    TermsFinanceCharge: data4.Terms.FinanceCharge,
                    IsTaxInclusive: data4.IsTaxInclusive,
                    Subtotal: data4.Subtotal,
                    SubtotalForeign: data4.SubtotalForeign,
                    Freight: data4.Freight,
                    FreightForeign: data4.FreightForeign,
                    FreightTaxCodeUID: data4.FreightTaxCode.UID,
                    TotalTax: data4.TotalTax,
                    TotalTaxForeign: data4.TotalTaxForeign,
                    TotalAmount: data4.TotalAmount,
                    TotalAmountForeign: data4.TotalAmountForeign,
                    CategoryUID: CategoryUID, // var
                    SalespersonUID: SalespersonUID, // var
                    Comment: data4.Comment,
                    ShippingMethod: data4.ShippingMethod,
                    JournalMemo: data4.JournalMemo,
                    ReferralSource: data4.ReferralSource,
                    InvoiceDeliveryStatus: data4.InvoiceDeliveryStatus,
                    LastPaymentDate: data4.LastPaymentDate,
                    CanApplySurcharge: data4.CanApplySurcharge,
                    OrderUID: OrderUID, // var
                    OnlinePaymentMethod: data4.OnlinePaymentMethod,
                    ForeignCurrency: data4.ForeignCurrency,
                    CurrencyExchangeRate: data4.CurrencyExchangeRate,
                    LastModified: data4.LastModified,
                    URI: data4.URI,
                    RowVersion: data4.RowVersion,
                    // invoice_id: data4.invoice_id // needed for update quiery.
                    invoice_id: sent_invoice_id // set manuall and test.
                          };


                    // this.invoice_model = this.invoice_model;
                    // this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
                    this.updateSubjectInvoiceByUID(this.invoice_model);

                // create a lines model with all new data and upate existing invoice_items
                // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                  let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                  let  count_of_items = Object.keys(newArr).length;
                  //  let res = data[0];
                  // Run the job data queries.
                  // need to do a loop of subject_billing items (.length)
                  for(let i=0;i < count_of_items; i++) {
                    let res = newArr[i];

                      // empty array of invoiceItemsList first
                      // this.invoiceItemsList = {};
                        let TaxCodeUID;
                        let JobUID;
                        let AccountUID;
                        let TaxCodeCode;

                        // console.log('TaxCodeUID:' +  res.TaxCode.UID);

                        // check for nulls on sub arrays
                        if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                          TaxCodeUID = null;
                          TaxCodeCode = null;
                        }else {
                          TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                          TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                        };
                        if (typeof res.Job === 'undefined' || res.Job === null ) {
                          JobUID = null;
                        }else {
                          JobUID = res.Job.UID; // can only call if actuall exist in the array!
                        };
                        if (typeof res.Account === 'undefined' || res.Account === null ) {
                          AccountUID = null;
                        }else {
                          AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                        };

                        this.invoiceItemsList = {
                          RowID: res.RowID,
                          Type: res.Type,
                          Description: res.Description,
                          UnitOfMeasure: res.UnitOfMeasure,
                          UnitCount: res.UnitCount,
                          UnitPrice: res.UnitPrice,
                          UnitPriceForeign: res.UnitPriceForeign,
                          DiscountPercent: res.DiscountPercent,
                          Total: res.Total,
                          TotalForeign: res.TotalForeign,
                          AccountUID: AccountUID, // var
                          JobUID: JobUID, // var
                          TaxCodeUID: TaxCodeUID, // var
                          TaxCodeCode: TaxCodeCode, // var
                          RowVersion: res.RowVersion
                                };

                          // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
                          // this.invoiceItemsList = this.invoiceItemsList;
                          if (this.invoiceItemsList !== '{}') {
                         this.updateSubjectInvoiceItem(this.invoiceItemsList, this.invoice_model.invoice_id);
                          };
                          } // End Lines Loop

                          //  this.toastr.info('Invoice Vrs Updated In SOP');
                 },
                 error => {
                   // console.error('Error saving Event!');
                    // this.toastr.error('Error Collecting Invoice Myob Details');
                   console.log(error.error);
                  },
                   () => {
                    //  console.log('.');
                          // now finally update the invoice
                          this.updateSubjectInvoice(model); // locally and one.
                          // this.refreshGrid();
                   }
                   );
                  };





setMyobPaymentModelStep1Single(model){

  // if (model.is_bulk === 1) {
  // }
console.log('SendModel:: ' + JSON.stringify(model));
this.getMyobAccountCodes();
this.getMyobTaxCodes();
  this.getInvoicePaymentsByPaymentIDStep(model.payment_id, model);

};


setMyobPaymentModelStep1(model){

  // if (model.is_bulk !== 1) { // this was the same maybe fix?
  // }
console.log('SendModel:: ' + JSON.stringify(model));
this.getMyobAccountCodes();
this.getMyobTaxCodes();
  this.getInvoicePaymentsByPaymentIDStepW(model.payment_id, model);

};


  // Get Invoice Payment Items
  getInvoicePaymentsByPaymentIDStep(payment_id, model){
    this._demoService.getInvoicePaymentsByPaymentID(payment_id)
    .pipe(
      this.toastr.observe({
         loading: 'Connecting...Pushing data...Updating',
         success: '🚀',
         error: '😡'
      })
    )
    .subscribe(
    // this._demoService.getInvoicePaymentsByPaymentIDInvoiceID(payment_id, model.invoice_id).subscribe(
      (data) => {
        this.paymentItemsList = data;
        let res = data[0];
        this.payment_item_model = this.paymentItemsList;

        this.setMyobPaymentModelStep2(model);
        console.log('PaymentItemsList: ' + JSON.stringify(this.payment_item_model));

      },
      (err) => {
        console.error(err)

// Need to set some error varibles
this.error_message = err.error.error_message;
this.error_message_standard = err.error.error_message_standard;
this.error_name = err.error.error_name;
this.full_response_data = err.error.full_response_data;
this.data_sent = err.error.data_sent;
this.data_sent_id = err.error.payment_id;
this.data_sent_DisplayID = err.error.data_sent.customer_UID;

//Set these up for payments
this.data_sent_client_brand_id = err.error.customer_UID;
this.data_sent_agent_brand_id = null;
this.data_sent_invoice_id = err.error.invoice_UID;
this.data_sent_invoice_UID = err.error.invoice_UID;
this.data_sent_client_invoice_id = err.error.invoice_id;
this.data_sent_agent_invoice_id = null;
// if(this.data_sent_invoice_UID != null){
// this.getSubjectInvoiceByInvoiceByUID(this.data_sent_invoice_UID) // gets the invoice the payment was applied to.

// }
this.data_sent_invoice_payment_id = err.error.payment_id;
this.data_sent_work_order_payment_id = null;

this.data_sent_work_order_id = null;
this.data_sent_work_order_UID = null;
this.data_sent_work_order_spending_id =null;
this.full_response_status = err.error.full_response_staus;
this.full_response_headers = err.error.full_response_headers;
this.full_response = err.error.full_response;

                
      },
    //  () => {
    //   this.setMyobPaymentModelStep2(model);
    //   console.log('PaymentItemsList: ' + JSON.stringify(this.payment_item_model));
    //   }
    )};


  // :: Create Payment.
  setMyobPaymentModelStep2(model){
// this is who made the payment details.
   this._demoService.getBrandById(model.to_brand_id).subscribe(
     data => { this.brand = data;
     const  resBrand = data[0];
                       this.brandData = resBrand;
                 console.log('Brand MyobID: ' + resBrand.myob_id);
                 console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                //  console.log('Payment Items Invoices: ' + JSON.stringify(this.payment_item_model));
                 // Model.- use return so that model is available in the outside subscription

// Meed to get a model of the Tax Code ID
// Memo if a subject or job invoice
// let JournalMemo;
// if (model.is_job_invoice >= 1) {
//  JournalMemo = 'Job Invoice';
// }else{
//  JournalMemo = 'Subject Invoice';
// };

// let BillDeliveryStatus;
// if (model.invoice_communication_status_id === 1) { // email
//  BillDeliveryStatus = 'Nothing';
// }else{
//  BillDeliveryStatus = 'Print';
// }

/*
Payment POST
*/
// get the account code.
let paymentAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === model.myob_account_code_id ));
let setMaymentAccount = paymentAccountUID[0].myob_account_id;
                      this.data_payment = {
                      'PayFrom': 'Account',
                      'Account': {
                      'UID': setMaymentAccount
                      },
                      'Customer': {
                      'UID': this.brandData.myob_id
                      },
                      'PayeeAddress': '',
                      'StatementParticulars': '',
                      'PaymentNumber': '1',
                      'Date': model.payment_date,
                      'AmountPaid': model.payment_total,
                      'Memo': 'SOP Payment; ' + this.brandData.name + ' SPID:' + model.payment_id,
                      'Invoices': [
                      //   {
                      //   'UID': '49dd6a4b-5b99-479d-8022-094f336da2d7',
                      //   'AmountApplied': 46.2,
                      //   'Type': 'Invoice'
                      // }
                      ],
                      'DeliveryStatus': 'Print',
                      'ForeignCurrency': null
                      };

                      // tslint:disable-next-line:max-line-length (these are Invoices)
                      let newArr = Object(this.payment_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                      let  count_of_items = Object.keys(newArr).length;

                      for(let i=0;i < count_of_items; i++) {
                      let res = newArr[i];

                      let new_line = {

                      'UID': res.myob_id,  // has to be an invoice ID code
                      'AmountApplied': model.payment_total,
                      'Type': 'Invoice'
                      };

                      this.data_payment.Invoices.push(new_line);
                      }

                      console.log('New Pushed Model: ' + JSON.stringify(this.data_payment));

                      console.log('payment model Loaded.');

                      this.createMyobPaymentModel(model, this.data_payment);


     },
     err => console.error(err),
    //  () =>  {
    //    console.log('payment model Loaded.');

    //  this.createMyobPaymentModel(model, this.data_payment);

    //  }
   );
    }

   


    createMyobPaymentModel(model, data_payment){
      // if (confirm('We are about to Sync this Payment and Items with MYOB, This will close all invoices local and Myob Cloud. Are you Sure?')) {
    // console.log('Payment Data: ' + JSON.stringify(data_payment));
   // combine the model to make invoice_id available
    // model = {
    //   ...model,
    //   ...data_payment
    // };
// console.log('Data Model Combined For Invoice Refresh: on POST: ' + JSON.stringify(model));

    // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
    if (this.data_payment != '{}' ) {
        this._demoService.createMyobPayment(this.data_payment)
        .pipe(
          retry(0), // you retry 3 times
          delay(1500) // each retry will start after 1 second,
       )
        .subscribe(
        data => { this.myobPaymentCreatedData = data;
          let res = data[0];
          let new_data_object = JSON.parse(this.myobPaymentCreatedData);
          let location_string = new_data_object.location;
          // get everything after last dash 
          let slug = location_string.split('/').pop(); // 2020
          console.log('UUID slug: ' + slug);
                      // model.myob_id = slug;
                      // model.sync_with_myob = 1;
                      // this.updateSubjectInvoice(model);
                      // this.editBrand(model);
                      // this.refreshGrid();
                      // this.toastr.info('Invoice Upgraded In SOP');
          // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                    // need to pass the brand model here as its updatting the full SOP brand details.
                    this._demoService.getMyobPaymentsMapped(slug, model)
                    .pipe(
                      retry(0), // you retry 3 times
                      delay(1500) // each retry will start after 1 second,
                   )
                    .subscribe(
                       data4 => {
                        console.log(data4);
                        res = data4[0];
                      // many
                        // this.myobContactListMapped = data.data;
                      //single
                
                    
                      this.myobPaymentListMapped = data4;
                      // Set the returned Variables Reququied for Update of a Myob Customer.
                      console.log('UID: ' +  data4.UID);
                      console.log('LastModified: ' + data4.LastModified);
                      console.log('RowVersion: ' + data4.RowVersion);
                      // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                      // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);

                      // this.set_RowVersion = data4.RowVersion;

                    // All Additional Myon Invoice Payment Variables
                      model.UID = data4.UID;
                      model.DepositTo = data4.DepositTo;
                      model.AccountUID = data4.Account.UID;
                      model.CustomerUID = data4.Customer.UID;
                      model.URI = data4.URI;
                      model.myob_array = JSON.stringify(data4);
                      model.RowVersion = data4.RowVersion;
                      model.myob_id = slug;
                      model.sync_with_myob = 1;

                                // Now run the payment records
                                console.log('End Payment Model: ' + JSON.stringify(model)); // current Payment Items to Update Paymet
                                console.log('myobPaymentListMapped: ' + JSON.stringify(this.myobPaymentListMapped));
                                console.log('Data4.UID: ' + data4.UID); // is paymentUID
                                this.updatePayment(model);  // updates the payment record. //1

                                },
                                err => {
                                  // console.error('Error saving Event!');
                                  //  this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
                                  console.log(err.error);

                                  // Need to set some error varibles
                                  this.error_message = err.error.error_message;
                                  this.error_message_standard = err.error.error_message_standard;
                                  this.error_name = err.error.error_name;
                                  this.full_response_data = err.error.full_response_data;
                                  this.data_sent = err.error.data_sent;
                                  this.data_sent_id = err.error.data_sent_invoice_id;

                                  this.response_from_node = JSON.stringify(err)
                                  this.response_from_node_raw = err;
                                  console.log('FullRespoonse Error createMyobWorkOrderModel(model, data_work_order): ' + this.response_from_node)
                                  return(this.response_from_node = JSON.stringify(err)); // do this so other componets get



                                 });

                      // } // end invoices paid that changed.

                                  // Now Updated: SUCCESSFULL invoice Paid. (Works and creates no errors!)
                                  // to get the invoice UID
                                  // this.lookupInvoiceUpdateInvoice2W(model.UID, model);
                                      model = {
                                        ...model,
                                        ...data_payment
                                      };
                                  console.log('Data Model Combined For Invoice Refresh: on POST: ' + JSON.stringify(model));
                              // tslint:disable-next-line:max-line-length
                              console.log('C model.Invoices[0]UID: ' + model.Invoices[0].UID);
                              this.myobApi_ITW.getMyobAccountCodes();
                              this.myobApi_ITW.getMyobAccountCodes();
                              // tslint:disable-next-line:max-line-length


                              // uncommented for testing must put back march 24
                        this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.Invoices[0].UID, model); // Get the invoice ID from the payment details array
                                    
                        this.toastr.info("we are here")

                              return JSON.stringify(model.Invoices[0]);

          // set up a global redirect so that it refreshed if included on two levels down.
          if (this.subject_id_check >= 1) {
          // this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
          }
        },
        err => {
          // this.toastr.error('You need to login to MYOB again, Connection lost!');
         console.log(err.error);


          // Need to set some error varibles
          this.error_message = err.error.error_message;
          this.error_message_standard = err.error.error_message_standard;
          this.error_name = err.error.error_name;
          this.full_response_data = err.error.full_response_data;
          this.data_sent = err.error.data_sent;
          this.data_sent_id = err.error.data_sent_invoice_id;

          this.response_from_node = JSON.stringify(err)
          this.response_from_node_raw = err;
          console.log('FullRespoonse Error createMyobWorkOrderModel(model, data_work_order): ' + this.response_from_node)
          return(this.response_from_node = JSON.stringify(err)); // do this so other componets get

        },
        () => {
          if (this.subject_id_check >= 1) {
       return(this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id)); // now reload the page
    

          };
            return true;
        }
      );
    }// end if invoice_data
     // }; // end confirm
    };


    updatePayment(model){
      this._demoService.updatePayment(model).subscribe(
        data => {  this.retuned_payment_update = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
      this.toastr.success('Local Payment Datas Updated');
         return true;
      },
        err => {
          console.log(err.error);
          return(this.response_from_node = JSON.stringify(err))
          //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
        );
         };
    
        // last scrupt to run on payment
    // last scrupt to run on payment
    updatePaymentLast(model){
      this._demoService.updatePayment(model).subscribe(
        data => {  this.retuned_payment_update = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
      // this.toastr.success('Local Payment Datas Updated');
        //  return true;
        // console.log('Subject_id: ' + this.subject_id);
        // console.log('update model: ' + JSON.stringify(model));


        
                                      // if (model.is_bulk === 1){
                                      //   // this.gfunc.globalAccountsClientInvoiceBulkPaymentViewSkipRoute(model.subject_id);
                                      // }else{
                                      // this.gfunc.globalJobSubjectBillingViewSkipRoute(model.subject_id);
                                      // // Only redirect if there is a subject id - undefined!
                                      // }


          return true;

      },
        err => {
          console.log(err.error);
          return(this.response_from_node = JSON.stringify(err))

       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
        );
         };


    
    
      // Get Invoice Payment Items
      getInvoicePaymentsByPaymentID(payment_id){
        this._demoService.getInvoicePaymentsByPaymentID(payment_id).subscribe(
          (data) => {
            this.paymentItemsList = data;
            let res = data[0];
            this.payment_item_model = this.paymentItemsList;
            // this.setMyobPaymentModelStep2(model); // ru
            // console.log('PaymentItemsList: ' + JSON.stringify(this.payment_item_model));
            // this.doCalculations();
          },
          (err) => console.error(err),
         () => console.log('Payment Invoices Items Loaded.')
        )};
    
    
        getSubjectInvoice(invoice_id){
          this._demoService.getSubjectInvoice(invoice_id).subscribe(
            data => {
              this.subject_invoice = data;
          let res = data[0];
          this.current_invoice_UID = res.UID;
             },
            err => console.error(err),
            // () => console.log('done loading Trace Types')
          );
        }
    
    
    getMyobAccountCodes() {
      this._demoService.getMyobAccountCodes().subscribe(
         data => { this.myob_account_codes = data;
          let res = data[0];
        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
     getMyobTaxCodes() {
      this._demoService.getMyobTaxCodes().subscribe(
         data => { this.myob_tax_codes = data;
          let res = data[0];
        },
         err => console.error(err),
         // () => console.log('done loading Trace Types')
       );
     }
    
    
    
      updateMyobInvoiceModelStep1(model){
        this.getUpdateInvoiceItmes(model.invoice_id, model);
          };
      
       // Get Invoice Items
      getUpdateInvoiceItmes(invoice_id, model){
        this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
          (data) => {
            this.invoiceItemsList = data;
            let res = data[0];
            this.invoice_item_model = this.invoiceItemsList;
            // this.setMyobInvoiceModelStep2(model); // ru
            this.updateMyobInvoiceModelStep2(model);
            // this.doCalculations();
          },
          (err) => console.error(err),
         () => console.log('Invoice Items Loaded.')
        )};
      
      
      
        updateMyobInvoiceModelStep2(model){
          this._demoService.getBrandById(model.to_brand_id).subscribe(
            data => { this.brand = data;
            const  res = data[0];
                              this.brandData = res;
                        console.log('Brand MyobID: ' + res.myob_id);
                        console.log('Brand ID MYOB: ' + this.brandData.myob_id);
                        console.log('Invoice Items: ' + JSON.stringify(this.invoice_item_model));
                        // Invoice Model.- use return so that model is available in the outside subscription
                       
       // Memo if a subject or job invoice
       let JournalMemo: string;
       if (model.is_job_invoice >= 1) {
         JournalMemo = 'Job Invoice';
       }else{
         JournalMemo = 'Subject Invoice';
       };
       
       let BillDeliveryStatus: string;
       if (model.invoice_communication_status_id === 1) { // email
         BillDeliveryStatus = 'Nothing';
       }else{
         BillDeliveryStatus = 'Print';
       }
       
       // NEed tp add the extra update records and IDS in model
       
                        this.data_invoice = {
                       'UID': model.UID, // update fields for model 
                       'RowVersion': model.RowVersion, // update
       
                        'Number': model.invoice_number, //  model.invoice_number
                        'Date': model.date_created,
                        'SupplierInvoiceNumber': model.SupplierInvoiceNumber,
                        'Customer': {
                        'UID': this.brandData.myob_id
                        },
                        'ShipToAddress': '' ,
                        'Terms': {
                        'PaymentIsDue': 'DayOfMonthAfterEOM',
                        'DiscountDate': 1,
                        'BalanceDueDate': 30,
                        'DiscountForEarlyPayment': 0,
                        'MonthlyChargeForLatePayment': 0,
                        'DiscountExpiryDate': model.due_date,
                        'Discount': 0,
                        'DueDate': model.due_date
                        },
                        'IsTaxInclusive': true,
                        'IsReportable': true,
       
                        'Lines': [
                        // {
                        // 'Type': '',
                        // 'Description': '' ,
                        // 'Account': {
                        // 'UID': 'd92626b4-1cbb-4ac9-8b46-856175f5c0a7'
                        // },
                        // 'Total': 6,
                        // 'Job': null,
                        // 'TaxCode': {
                        // 'UID': '8d273078-fe1d-4c16-b318-ec7a2b7fb2fe'
                        // }
                        // },
                        ],
       
                        'Subtotal': model.invoice_subtotal,
                        'Freight': 0,
                        'FreightTaxCode': {
                        'UID': this.gfunc.myob_FreightTaxCode
                        },
                        'TotalTax': model.invoice_gst,
                        'TotalAmount': model.invoice_total,
                        'Category': null,
                        'Comment': '',
                        'ShippingMethod': null,
                        'PromisedDate': null,
                        'JournalMemo': 'SOP: ' + JournalMemo + ' ' + model.invoice_number,
                        'BillDeliveryStatus': BillDeliveryStatus,
                        'AppliedToDate': 0,
                        'BalanceDueAmount': model.invoice_remaining_total,
                        'Status': 'Open',
                        'LastPaymentDate': null,
                        'Order': null,
                        'ForeignCurrency': null
                        };
       
       
       
                            // :: This function Collects and pushes the lines to the rows of the invoice.
                        // console.log('Invoice Items: 2 ' + JSON.stringify(this.invoiceItemsList));
                        // need to loop through the invoice model and create Lines.
       
                        let newArr = Object(this.invoice_item_model).filter((sbi)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
       
                        let  count_of_items = Object.keys(newArr).length;
                        //  let res = data[0];
                        // Run the job data queries.
                        // need to do a loop of subject_billing items (.length)
                        for(let i=0;i < count_of_items; i++) {
                          let res2 = newArr[i];
       
       
                           // get a list of all the account ID/s in an array  -- THIS WORKS SO WELL!!!!!!
                                         // this.getMyobTaxCodes(); // load this onInit.
                                         // this.getMyobAccountCodes();
                         const retTaxCodeUID = Object(this.myob_tax_codes).filter((mtc)=>(mtc.myob_tax_code_id === res2.myob_tax_code_id ));
                         const retAccountUID = Object(this.myob_account_codes).filter((mac)=>(mac.myob_account_code_id === res2.myob_account_code_id ));
                         // console.log('Tax Acc: ' + JSON.stringify(retTaxCodeUID));
                         // console.log('Myob Acc: ' + JSON.stringify(retAccountUID));
       
                         let TaxAccountUID = retTaxCodeUID[0].UID;
                         let MyobAccountUID = retAccountUID[0].UID;
       
                         console.log('Tax Code: ' + retTaxCodeUID[0].UID);
                         console.log('Acc Code: ' + retAccountUID[0].UID);
       
       
                         //  let new_line = {
                         //    'RowID': res.RowID, // requored update
                         //    'RowVersion': res.RowVersion, // required Update
                         //    'Type': 'Transaction',
                         //    'Description': res.billing_task_name,
                         //    'Account': {
                         //    'UID': MyobAccountUID,
                         //    },
                         //    'Total': res.total,
                         //    'Job': null,
                         //    'TaxCode': {
                         //    'UID': TaxAccountUID
                         //    }
                         //    };
       
                         this.new_line = null; // reset
       
                         // :: Determine to update row or insert new if Lines.RowID exista
       
                         if(res2.RowID != null) {
                         this.new_line = {
                           'RowID': res2.RowID, // requored update
                           'RowVersion': res2.RowVersion, // required Update
                           'Type': 'Transaction',
                           'Description': res2.billing_task_name,
                           'Account': {
                           'UID': MyobAccountUID,
                           },
                           'Total': res2.total,
                           'Job': null,
                           'TaxCode': {
                           'UID':  TaxAccountUID
                           }
                           };
                         }; // end update line
       
                         if (res2.RowID == null) {
                           this.new_line = {
                             // 'RowID': res2.RowID, // requored update
                             // 'RowVersion': res2.RowVersion, // required Update
                             'Type': 'Transaction',
                             'Description': res2.billing_task_name,
                             'Account': {
                             'UID': MyobAccountUID,
                             },
                             'Total': res2.total,
                             'Job': null,
                             'TaxCode': {
                             'UID':  TaxAccountUID
                             }
                             };
                           }; // end new line.
       
       
                        this.data_invoice.Lines.push(this.new_line);
                        }
       
                        console.log('Update Pushed Model: ' + JSON.stringify(this.data_invoice));
       
       
            },
            err => console.error(err),
            () =>  {
              console.log('invoice model Loaded.');
            this.updateMyobInvoiceModel(model, this.data_invoice);
            }
          );
           
            //   await this.delay(3000);
            //  })(); // end async function
       
            /// PUT DOUBLE FUNCTION ON BUTTON AS IT WAS NOT RUNNINT CORRCTly - now a process of three functions.
             // Loads first so that the rest of the subscription can run.
          // this.getInvoiceItmes(model.invoice_id);
       
       }
       
       
       updateMyobInvoiceModel(model, data_invoice) {
         if (confirm('We are about to Sync and Update Invoice data to MYOB, Are you Sure?')) {
           // console.log('Invoice Data: ' + JSON.stringify(data_invoice));
           
           // :: Ideally need to get a response from insert of the UID of the customer to insert back in sop brands to know th e link has taken place.
           if (this.data_invoice != '{}' ) {
               this._demoService.updateMyobInvoice(this.data_invoice).subscribe(
               data => { this.myobInvoiceUpdatedData = data;
                 let res = data[0];
                 let new_data_object = JSON.parse(this.myobInvoiceUpdatedData);
           
           
                 let location_string = new_data_object.location;
                 // get everything after last dash 
                 let slug = location_string.split('/').pop(); // 2020
                 console.log('UUID slug: ' + slug);
           
                             // model.myob_id = slug;
                             // model.sync_with_myob = 1;
                             // this.updateSubjectInvoice(model);
                             // this.editBrand(model);
                             // this.refreshGrid();
                             // this.toastr.info('Invoice Upgraded In SOP');
           
                 // :: Need to lookup myoub get UID/myobid and fill rest of model.vars.
                           // need to pass the brand model here as its updatting the full SOP brand details.
                           this._demoService.getMyobInvoiceMapped(slug, model).subscribe(
                              data4 => {
                               console.log(data4);
                               res = data4[0];
                             // many
                               // this.myobContactListMapped = data.data;
                             //single
                               this.myobInvoiceListMapped = data4;
                             // Set the returned Variables Reququied for Update of a Myob Customer.
                             console.log('UID: ' +  data4.UID);
                             console.log('LastModified: ' + data4.LastModified);
                             console.log('RowVersion: ' + data4.RowVersion);
                             // console.log('TaxCodeUID: ' +  data4.SellingDetails.TaxCode.UID);
                             // console.log('Sale Layout: ' +  data4.SellingDetails.SaleLayout);
       
       
                         // work out the nulls for sub arraryas
                         let CategoryUID;
                         let OrderUID;
                         let SalespersonUID
       
                         if (typeof model.Category === 'undefined' || model.Category === null ) {
                           CategoryUID = null;
                         }else {
                           CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
                         };
                         if (typeof model.Order === 'undefined' || model.Order === null ) {
                           OrderUID = null;
                         }else {
                           OrderUID = model.Category.UID; // can only call if actuall exist in the array!
                         };
                         if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
                           SalespersonUID = null;
                         }else {
                           SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
                         };
       
       
       
       
       
                             this.set_RowVersion = data4.RowVersion;
                             // model.IsIndividual = data4.IsIndividual;
                             // model.SaleLayout = data4.SellingDetails.SaleLayout;
                             // model.InvoiceDelivery = data4.SellingDetails.InvoiceDelivery;
                             // model.TaxCode = data4.SellingDetails.TaxCode.UID;
                             // model.FreightTaxCode = data4.SellingDetails.FreightTaxCode.UID;
                             model.RowVersion = data4.RowVersion;
                             model.myob_array = JSON.stringify(data4);
                             model.myob_id = slug;
                             model.sync_with_myob = 1;
           
                             
       
       
       
       // All Additional Myon Invoice Variables
       model.UID = data4.UID;
       model.Number = data4.Number;
       model.Date = data4.Date;
       model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
       model.CustomerUID = data4.Customer.UID;
       model.CustomerName = data4.Customer.Name;
       model.CustomerDisplayID = data4.Customer.DisplayID;
       model.PromisedDate = data4.PromisedDate;
       model.BalanceDueAmount = data4.BalanceDueAmount;
       model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
       model.Status = data4.Status;
       model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
       model.TermsDiscountDate = data4.Terms.DiscountDate;
       model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
       model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
       model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
       model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
       model.TermsDiscount = data4.Terms.Discount;
       model.TermsDueDate = data4.Terms.DueDate;
       model.TermsFinanceCharge = data4.Terms.FinanceCharge;
       model.IsTaxInclusive = data4.IsTaxInclusive;
       model.Subtotal = data4.Subtotal;
       model.SubtotalForeign = data4.SubtotalForeign;
       model.Freight = data4.Freight;
       model.FreightForeign = data4.FreightForeign;
       model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
       model.TotalTax = data4.TotalTax;
       model.TotalTaxForeign = data4.TotalTaxForeign;
       model.TotalAmount = data4.TotalAmount;
       model.TotalAmountForeign = data4.TotalAmountForeign;
       model.CategoryUID = CategoryUID; // var
       model.SalespersonUID = SalespersonUID; // var
       model.Comment = data4.Comment;
       model.ShippingMethod = data4.ShippingMethod;
       model.JournalMemo = data4.JournalMemo;
       model.ReferralSource = data4.ReferralSource;
       model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
       model.LastPaymentDate = data4.LastPaymentDate;
       model.CanApplySurcharge = data4.CanApplySurcharge;
       model.OrderUID = OrderUID; // var
       model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
       model.ForeignCurrency = data4.ForeignCurrency;
       model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
       model.LastModified = data4.LastModified;
       model.URI = data4.URI;
       model.RowVersion = data4.RowVersion;
       
       
       
                      // TOD I NEED TO GET THE LINE ID's and RowVersions to be able to update the Invoice. I THink?
                      // UPDATE the invoice Items RowID, RowVersion and other details.
                          // HERE NOW
       
       
       
                                // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
                                let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
                                let  count_of_items = Object.keys(newArr).length;
                                //  let res = data[0];
                                // Run the job data queries.
                                // need to do a loop of subject_billing items (.length)
                                for(let i=0;i < count_of_items; i++) {
                                  let res = newArr[i];
       
                                // empty array of invoiceItemsList first
                                this.invoiceItemsList = {};
       
                                  let TaxCodeUID;
                                  let JobUID;
                                  let AccountUID;
                                  let TaxCodeCode;
       
                                console.log('TaxCodeUID:' +  res.TaxCode.UID);
       
                                // check for nulls on sub arrays
                                if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
                                TaxCodeUID = null;
                                TaxCodeCode = null;
                                }else {
                                TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
                                TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
                                };
                                if (typeof res.Job === 'undefined' || res.Job === null ) {
                                JobUID = null;
                                }else {
                                JobUID = res.Job.UID; // can only call if actuall exist in the array!
                                };
                                if (typeof res.Account === 'undefined' || res.Account === null ) {
                                AccountUID = null;
                                }else {
                                AccountUID = res.Account.UID; // can only call if actuall exist in the array!
                                };
       
                                // so we can insert new items or remove ones that do not exist.
                                // NEW
                                this.invoiceItemsList = { 
                                RowID: res.RowID,
                                Type: res.Type,
                                Description: res.Description,
                                UnitOfMeasure: res.UnitOfMeasure,
                                UnitCount: res.UnitCount,
                                UnitPrice: res.UnitPrice,
                                UnitPriceForeign: res.UnitPriceForeign,
                                DiscountPercent: res.DiscountPercent,
                                Total: res.Total,
                                TotalForeign: res.TotalForeign,
                                AccountUID: AccountUID, // var
                                JobUID: JobUID, // var
                                TaxCodeUID: TaxCodeUID, // var
                                TaxCodeCode: TaxCodeCode, // var
                                RowVersion: res.RowVersion
                                      };
       
                                console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
                                // this.invoiceItemsList = this.invoiceItemsList;
                                if (this.invoiceItemsList !== '{}') {
                                  // we udate each item in the loop that was just inserted.
                                this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
                                };
                                } // End Lines Loop
       
       
       
       
       
                             this.updateSubjectInvoice(model);
                            //  this.toastr.info('Invoice Upgraded In Myob');
                             this.refreshGrid();
                           },
                           error => {
                             // console.error('Error saving Event!');
                              // this.toastr.error('Error Updating Invoice to Myob Details');
                             console.log(error.error);
                            });
           
           
                           //  model.RowVersion = this.set_RowVersion;
           
           
                             
                               //  model.RowVersion = this.set_RowVersion;
                           //  model.myob_customer_array = JSON.stringify(this.myobContactListMapped);
           
           
                 // let new_data_string = JSON.stringify(this.myobCustomerCreatedData);
                 // console.log('new_data date: ' + new_data_string.date);
                 // console.log('new_data date: ' + new_data_string.location);
           
                 // console.log(this.myobCustomerCreatedData.location);
                 // // https://www.concretepage.com/questions/577
                 //  this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
                 //  // console.log(this.arrCase);
                 //  this.Items = data['Items'] ;
           
               
               },
               err => {
                 // this.toastr.error('You need to login to MYOB again, Connection lost!');
                console.log(err.error);
               },
               // () => console.log('done loading Trace Types')
             );
           }// end if invoice_data
           
             }; // end confirm
           
       
       };


public getMyobInvoices() {
        this._demoService.getMyobInvoices().subscribe(
          data => { this.myobInvoices = data;
            const res = data[0];
             // https://www.concretepage.com/questions/577
             this.arrCase = data as object [];  // FILL THE ARRAY WITH DATA.
             // console.log(this.arrCase);
             this.Items = data['Items'] ;
             console.log(this.Items);
            // this.Address = this.Items['Address'];
      // return this.myobCustomers;

      // Map the data top the new model system
      // this.Items.map(data => data.map(data => new MyobContact().deserialize(data)));
          },
          err => {
            // this.toastr.error('You need to login to MYOB again, Connection lost!');
            console.error(err);
          },
          // () => console.log('done loading Trace Types')
        );

      }


deleteMyobServiceInvoicePaymentModel(model, invoiceUID){
      // console.log('Passed Delete Model ' + JSON.stringify(model));
        // NOT WORKING AS THERE IS NOT ID!
        // lookup the invoices and set a loop model (invoice payments) to update once delted from model.payment_id
        this.getInvoicePaymentsByPaymentID(model.payment_id); // resets the payment item model as its never loaded or used on delete.
    // console.log('Ivoices Payment Deleted Effected: ' + JSON.stringify(this.payment_item_model));
        // Get Payment RowVersion Updates First.
        // this.myobApi_ITW.lookupInvoiceUpdateInvoice2(model.UID, model); // THIS WORKS.
        this.getMyobPaymentsMappedAndUpdateLocal(model.payment_id, model); // resets row versions locally before attempting changes
        this.deleteMyobServiceInvoicePaymentModelStep2(model, invoiceUID);
  };


/// USING FROM ANOTHER COMPONENT
      deleteMyobServiceInvoicePaymentModelStep2(model, invoiceUID){
        if(invoiceUID) {
        model.sent_UID = invoiceUID;
      }
        // if (confirm('This will delete this Payment and updated Invoices in Myob, Are you Sure?')) {
      this._demoService.deleteMyobPayment(model)
      .pipe(
        retry(2), // you retry 3 times
        delay(1500) // each retry will start after 1 second,
     )
      .subscribe(
          data => { this.myobPaymentDeletedData = data;
            let res = data[0];
          
        this.toastr.success('Payment Remved from Invoice in Myob');

            const savedPaymentUID = model.UID;
          
            model.myob_id = null;
            model.UID = null;
            model.sync_with_myob = null;
                    // All Additional Myon Invoice Payment Variables
                    model.UID = null;
                    model.DepositTo = null;
                    model.AccountUID = null;
                    model.CustomerUID = null;
                    model.URI = null;
                    model.myob_array = null;
                    model.RowVersion = null;
                    model.myob_id = null;

                               // this.lookupInvoiceUpdateInvoice2(inv_res.myob_id, data);
                   // tslint:disable-next-line:max-line-length
                  //  this.myobApi_ITW.lookupInvoiceUpdateInvoice2(invoiceUID, model); // having ussies finding the uncpuce UID on delete
                        this.updatePayment(model); // update local payment model on invoice (removed payment status)
                        console.log('Invoice to Update: ' + model.UID); // payment UID
                                  // Now Updatel invoice Paid.
                                  // to get the invoice UID - lookup on load function from observable invoice_id
                          // tslint:disable-next-line:max-line-length
                //          this.myobApi_ITW.getMyobAccountCodes();
                //          this.myobApi_ITW.getMyobAccountCodes();
                          // tslint:disable-next-line:max-line-length
// :::             this.myobApi_ITW.lookupInvoiceUpdateInvoice2(this.current_invoice_UID, model); // Get the invoice ID from the payment details array (had to lookup first!)



  

          },
          err => {
            // this.toastr.error('You need to login to MYOB again, Connection lost!');
           // console.error(err);


            // Need to set some error varibles
            this.error_message = err.error.error_message;
            this.error_message_standard = err.error.error_message_standard;
            this.error_name = err.error.error_name;
            this.full_response_data = err.error.full_response_data;
            this.data_sent = err.error.data_sent;
            this.data_sent_id = err.error.data_sent_invoice_id;



            this.response_from_node = JSON.stringify(err)
            this.response_from_node_raw = err;
            console.log('deleteMyobServiceInvoicePaymentModelStep2(model, invoiceUID): ' + this.response_from_node)
            return(this.response_from_node = JSON.stringify(err)); // do this so other componets get

            return JSON.stringify(err);

          },
          () => {
      //      this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);  // Feb 2023 turned off to stop errors in removing billing payment.. in the middle of the job...
        
         return true;
        } // redirects back to billing item page
          );
        // }; // end confirm
      };



   lookupInvoiceUpdateInvoice2(UID, model){
    this._demoService.getMyobInvoiceMapped(UID, model).subscribe(
      data4 => {
       console.log(data4);
       let res = data4[0];
       this.myobInvoiceListMapped = data4;
     // Set the returned Variables Reququied for Update of a Myob Customer.
    //  console.log('UID: ' +  data4.UID);
    console.log('UID: ' +  data4.UID);
    // console.log('retInvoiceModel: ' +  JSON.stringify(data4));
  
 const sent_invoice_id = UID;
//  const sent_real_invoice_id = model.invoice_id;


// this.invoice_model = {}; // clear the invoice moddl.
  
  // work out the nulls for sub arraryas
  let CategoryUID;
  let OrderUID;
  let SalespersonUID
  
  if (typeof model.Category === 'undefined' || model.Category === null ) {
    CategoryUID = null;
  }else {
    CategoryUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Order === 'undefined' || model.Order === null ) {
    OrderUID = null;
  }else {
    OrderUID = model.Category.UID; // can only call if actuall exist in the array!
  };
  if (typeof model.Salesperson === 'undefined' || model.Salesperson === null ) {
    SalespersonUID = null;
  }else {
    SalespersonUID = model.Category.UID; // can only call if actuall exist in the array!
  };



    this.set_RowVersion = data4.RowVersion;
    // Local data vars.
    //  model.myob_array = JSON.stringify(data4);
    //  model.myob_id = data4.UID;
  
    //  model.UID = data4.UID;
    //  model.Number = data4.Number;
    //  model.Date = data4.Date;
    //  model.CustomerPurchaseOrderNumber = data4.CustomerPurchaseOrderNumber;
    //  model.CustomerUID = data4.Customer.UID;
    //  model.CustomerName = data4.Customer.Name;
    //  model.CustomerDisplayID = data4.Customer.DisplayID;
    //  model.PromisedDate = data4.PromisedDate;
    //  model.BalanceDueAmount = data4.BalanceDueAmount;
    //  model.BalanceDueAmountForeign = data4.BalanceDueAmountForeign;
    //  model.Status = data4.Status;
    //  model.TermsPaymentIsDue = data4.Terms.PaymentIsDue;
    //  model.TermsDiscountDate = data4.Terms.DiscountDate;
    //  model.TermsBalanceDueDate = data4.Terms.BalanceDueDate;
    //  model.TermsDiscountForEarlyPayment = data4.Terms.DiscountForEarlyPayment;
    //  model.TermsMonthlyChargeForLatePayment = data4.Terms.MonthlyChargeForLatePayment;
    //  model.TermsDiscountExpiryDate = data4.Terms.DiscountExpiryDate;
    //  model.TermsDiscount = data4.Terms.Discount;
    //  model.TermsDueDate = data4.Terms.DueDate;
    //  model.TermsFinanceCharge = data4.Terms.FinanceCharge;
    //  model.IsTaxInclusive = data4.IsTaxInclusive;
    //  model.Subtotal = data4.Subtotal;
    //  model.SubtotalForeign = data4.SubtotalForeign;
    //  model.Freight = data4.Freight;
    //  model.FreightForeign = data4.FreightForeign;
    //  model.FreightTaxCodeUID = data4.FreightTaxCode.UID;
    //  model.TotalTax = data4.TotalTax;
    //  model.TotalTaxForeign = data4.TotalTaxForeign;
    //  model.TotalAmount = data4.TotalAmount;
    //  model.TotalAmountForeign = data4.TotalAmountForeign;
    //  model.CategoryUID = CategoryUID; // var
    //  model.SalespersonUID = SalespersonUID; // var
    //  model.Comment = data4.Comment;
    //  model.ShippingMethod = data4.ShippingMethod;
    //  model.JournalMemo = data4.JournalMemo;
    //  model.ReferralSource = data4.ReferralSource;
    //  model.InvoiceDeliveryStatus = data4.InvoiceDeliveryStatus;
    //  model.LastPaymentDate = data4.LastPaymentDate;
    //  model.CanApplySurcharge = data4.CanApplySurcharge;
    //  model.OrderUID = OrderUID; // var
    //  model.OnlinePaymentMethod = data4.OnlinePaymentMethod;
    //  model.ForeignCurrency = data4.ForeignCurrency;
    //  model.CurrencyExchangeRate = data4.CurrencyExchangeRate;
    //  model.LastModified = data4.LastModified;
    //  model.URI = data4.URI;
    //  model.RowVersion = data4.RowVersion;
  

     
// make the function more universal? or make custom by itself?
     this.invoice_model = {
      myob_array: JSON.stringify(data4),
      myob_id: data4.UID,
      UID: data4.UID,
      Number: data4.Number,
      Date: data4.Date,
      CustomerPurchaseOrderNumber: data4.CustomerPurchaseOrderNumber,
      CustomerUID: data4.Customer.UID,
      CustomerName: data4.Customer.Name,
      CustomerDisplayID: data4.Customer.DisplayID,
      PromisedDate: data4.PromisedDate,
      BalanceDueAmount: data4.BalanceDueAmount,
      BalanceDueAmountForeign: data4.BalanceDueAmountForeign,
      Status: data4.Status,
      TermsPaymentIsDue: data4.Terms.PaymentIsDue,
      TermsDiscountDate: data4.Terms.DiscountDate,
      TermsBalanceDueDate: data4.Terms.BalanceDueDate,
      TermsDiscountForEarlyPayment: data4.Terms.DiscountForEarlyPayment,
      TermsMonthlyChargeForLatePayment: data4.Terms.MonthlyChargeForLatePayment,
      TermsDiscountExpiryDate: data4.Terms.DiscountExpiryDate,
      TermsDiscount: data4.Terms.Discount,
      TermsDueDate: data4.Terms.DueDate,
      TermsFinanceCharge: data4.Terms.FinanceCharge,
      IsTaxInclusive: data4.IsTaxInclusive,
      Subtotal: data4.Subtotal,
      SubtotalForeign: data4.SubtotalForeign,
      Freight: data4.Freight,
      FreightForeign: data4.FreightForeign,
      FreightTaxCodeUID: data4.FreightTaxCode.UID,
      TotalTax: data4.TotalTax,
      TotalTaxForeign: data4.TotalTaxForeign,
      TotalAmount: data4.TotalAmount,
      TotalAmountForeign: data4.TotalAmountForeign,
      CategoryUID: CategoryUID, // var
      SalespersonUID: SalespersonUID, // var
      Comment: data4.Comment,
      ShippingMethod: data4.ShippingMethod,
      JournalMemo: data4.JournalMemo,
      ReferralSource: data4.ReferralSource,
      InvoiceDeliveryStatus: data4.InvoiceDeliveryStatus,
      LastPaymentDate: data4.LastPaymentDate,
      CanApplySurcharge: data4.CanApplySurcharge,
      OrderUID: OrderUID, // var
      OnlinePaymentMethod: data4.OnlinePaymentMethod,
      ForeignCurrency: data4.ForeignCurrency,
      CurrencyExchangeRate: data4.CurrencyExchangeRate,
      LastModified: data4.LastModified,
      URI: data4.URI,
      RowVersion: data4.RowVersion,
      // invoice_id: data4.invoice_id // needed for update quiery.
      invoice_id: sent_invoice_id // set manuall and test.
            };

    //   console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    //   // this.invoiceItemsList = this.invoiceItemsList;
    //   if (this.invoiceItemsList !== '{}') {
    //     // we udate each item in the loop that was just inserted.
    //   this.updateSubjectInvoiceItem(this.invoiceItemsList, model.invoice_id);
    //   };


// this.invoice_model = this.invoice_model;
// this.updateSubjectInvoice(this.invoice_model); // changed so that UID instead of invoice ID
this.updateSubjectInvoiceByUID(this.invoice_model);

  // create a lines model with all new data and upate existing invoice_items
  // ONLY LINES LOOP: go through the data4.Lines[] array to set update model invoice items locally
    let newArr = Object(data4.Lines).filter((ii)=>(1===1)); // sbi.invoice_status === 'NOT-INVOICED'- old filter
    let  count_of_items = Object.keys(newArr).length;
    //  let res = data[0];
    // Run the job data queries.
    // need to do a loop of subject_billing items (.length)
    for(let i=0;i < count_of_items; i++) {
      let res = newArr[i];
  
    // empty array of invoiceItemsList first
    this.invoiceItemsList = {};
  
      let TaxCodeUID;
      let JobUID;
      let AccountUID;
      let TaxCodeCode;
  
  // console.log('TaxCodeUID:' +  res.TaxCode.UID);
  
  // check for nulls on sub arrays
  if (typeof res.TaxCode === 'undefined' || res.TaxCode === null ) {
    TaxCodeUID = null;
    TaxCodeCode = null;
  }else {
    TaxCodeUID = res.TaxCode.UID; // can only call if actuall exist in the array!
    TaxCodeCode = res.TaxCode.Code; // can only call if actuall exist in the array!
  };
  if (typeof res.Job === 'undefined' || res.Job === null ) {
    JobUID = null;
  }else {
    JobUID = res.Job.UID; // can only call if actuall exist in the array!
  };
  if (typeof res.Account === 'undefined' || res.Account === null ) {
    AccountUID = null;
  }else {
    AccountUID = res.Account.UID; // can only call if actuall exist in the array!
  };
  
  this.invoiceItemsList = {
    RowID: res.RowID,
    Type: res.Type,
    Description: res.Description,
    UnitOfMeasure: res.UnitOfMeasure,
    UnitCount: res.UnitCount,
    UnitPrice: res.UnitPrice,
    UnitPriceForeign: res.UnitPriceForeign,
    DiscountPercent: res.DiscountPercent,
    Total: res.Total,
    TotalForeign: res.TotalForeign,
    AccountUID: AccountUID, // var
    JobUID: JobUID, // var
    TaxCodeUID: TaxCodeUID, // var
    TaxCodeCode: TaxCodeCode, // var
    RowVersion: res.RowVersion
          };
    
    // console.log('InvoiceItemsUpdateModel: ' + JSON.stringify(this.invoiceItemsList));
    // this.invoiceItemsList = this.invoiceItemsList;
    if (this.invoiceItemsList !== '{}') {
    this.updateSubjectInvoiceItem(this.invoiceItemsList, this.invoice_model.invoice_id);
    };
    } // End Lines Loop
  
  
     this.toastr.info('Invoice Vrs Updated In SOP');
     // now finally update the invoice
    //  this.updateSubjectInvoice(model);
        // this.refreshGrid();
   },
   err => {
     // console.error('Error saving Event!');
      this.toastr.error('Error Collecting Invoice Myob Details');
     console.log(err.error);

          // Need to set some error varibles
          this.error_message = err.error.error_message;
          this.error_message_standard = err.error.error_message_standard;
          this.error_name = err.error.error_name;
          this.full_response_data = err.error.full_response_data;
          this.data_sent = err.error.data_sent;
          this.data_sent_id = err.error.data_sent_invoice_id;

          this.response_from_node = JSON.stringify(err)
          this.response_from_node_raw = err;
          console.log('FullRespoonse Error createMyobWorkOrderModel(model, data_work_order): ' + this.response_from_node)
          return(this.response_from_node = JSON.stringify(err)); // do this so other componets get


     
    });
  }; // end loopup and update function
  
  
  
  
   // Get Invoice Items - Normal get
   getInvoiceItems(invoice_id){
    this._demoService.getSubjectInvoiceItems(invoice_id).subscribe(
      (data) => {
        this.invoiceItemsList = data;
        let res = data[0];
        this.invoice_item_model = this.invoiceItemsList;
        // this.setMyobInvoiceModelStep2(model); // ru
        // this.updateMyobInvoiceModelStep2(model);
        // this.doCalculations();
      },
      (err) => console.error(err),
     () => console.log('Invoice Items Loaded.')
    )};
  

    updateSubjectInvoiceByUID(invoice_model){
      this._demoService.updateSubjectInvoiceByUID(invoice_model).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
      this.toastr.success('Local Invoice Updated');
         return true;
        },
        error => {
          console.log(error.error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }
    
     updateSubjectInvoice(invoice_model){
      this._demoService.updateSubjectInvoice(invoice_model).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
        this.toastr.success('Local Invoice Updated');
         return true;
        },
        error => {
          console.log(error.error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }
    

     myobChecker() {
      this._demoService.myobChecker().subscribe(
         data => { this.myob_checker = data;
          // let res = data[0];
          // this.toastr.success('Myob Connections Active!... functions allowed');
    // console.log('Connected: ', JSON.stringify(this.myob_checker));
    this.myob_response = true;
        },
         err => (
          // this.toastr.success('Myob Connections Not Active! Please connect again.', err.error),
          this.myob_response= false,
          console.error(err)
         ),
         // () => console.log('done loading Trace Types')
       );
     }
  



    updateSubjectInvoiceItem(model, invoice_id){
      this._demoService.updateSubjectInvoiceItemByDescription(model, invoice_id).subscribe(
        data => {  // this.new_invoice_id = data; // this is the retuned json upon creation.
          // let res = data[0];
        // this.router.navigate(['../../companies'], { relativeTo: this.route });
         return true;
        },
        error => {
          console.error(error);
       //  this.toastr.error('Adding Failed :: Please try again!');
         // console.log(Observable.throw(error));
          // return Observable.throw(error);
        }
    )
     }
  
  
  editBrand(model){
    // model.job_id = this.job_id;
     this._demoService.updateBrand(model).subscribe(
       data => {  // this.trace_candidate_update = data;
         // refresh the list
        // this.getTraceCandidate(this.model.trace_candidate_id);  // created bugs...
       this.toastr.success('Company Updated');
       this.gfunc.insertLog_UpdateCompany(model); // hadled in the global functions file.
      // this.router.navigateByUrl('admin/clients', {skipLocationChange: true}).then(() =>
      // this.router.navigate(['/admin/jobs/subject/edit/' + model.subject_id + '']));
       },
       error => {
        // console.error('Error saving Event!');
         this.toastr.error('Error Updating Brand');
        return console.log(error);
       }
      // err => console.error(err),
      // () => console.log('done updates')
   );}

    refreshGrid(){ // refresh the databutton
      // this.getBrandJobsTableDataGrid(this.brand_id, this.job_status_code, this.assigned_agent);
      // this.getPayments();
      //  this.grid.refresh();
     };

      /// slug = Payment.UID
     getMyobPaymentsMapped(slug,  model){
      this._demoService.getMyobPaymentsMapped(slug, model).subscribe(
        data4 => {
        //  console.log(data4);
         let res = data4[0];
       this.myobPaymentListMapped = data4;
       // Set the returned Variables Reququied for Update of a Myob Customer.
       // console.log('UID: ' +  data4.UID);
       // console.log('LastModified: ' + data4.LastModified);
       // console.log('RowVersion: ' + data4.RowVersion);
       this.set_RowVersion = data4.RowVersion;
     // All Additional Myon Invoice Payment Variables
       model.UID = data4.UID;
       model.DepositTo = data4.DepositTo;
       model.AccountUID = data4.Account.UID;
       model.CustomerUID = data4.Customer.UID;
       model.URI = data4.URI;
       model.myob_array = JSON.stringify(data4);
       model.RowVersion = data4.RowVersion;                  //// !!!!!!
       model.myob_id = slug;
       model.sync_with_myob = 1;

      //  console.log('model.InvoiceUID: ' + model.UID); // current Items InvoiceUID

      //  // Now run the payment records
      //  this.updatePaymentLast(model);  // updates the payment record. //1
       this.toastr.info('Invoice Payments + Items Vrs Upgraded In SOP');
      //  // this.refreshGrid();
      //  this.getPayment(model.payment_id); // just tring to regresh comppoentent after create

     // set up a global redirect so that it refreshed if included on two levels down.
     if (this.subject_id_check >= 1) {
      // this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
      }

     },
     error => {
       // console.error('Error saving Event!');
       //  this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
       console.log(error.error);
      });

     };



      /// slug = Payment.UID
     getMyobPaymentsMappedAndUpdateLocal(slug,  model){
        this._demoService.getMyobPaymentsMapped(slug, model).subscribe(
          data4 => {
          //  console.log(data4);
           let res = data4[0];
         this.myobPaymentListMapped = data4;
         // Set the returned Variables Reququied for Update of a Myob Customer.
         // console.log('UID: ' +  data4.UID);
         // console.log('LastModified: ' + data4.LastModified);
         // console.log('RowVersion: ' + data4.RowVersion);
         this.set_RowVersion = data4.RowVersion;
       // All Additional Myon Invoice Payment Variables
         model.UID = data4.UID;
         model.DepositTo = data4.DepositTo;
         model.AccountUID = data4.Account.UID;
         model.CustomerUID = data4.Customer.UID;
         model.URI = data4.URI;
         model.myob_array = JSON.stringify(data4);
         model.RowVersion = data4.RowVersion;       ///// !!!!!
         model.myob_id = slug;
         model.sync_with_myob = 1;

          console.log('model.InvoiceUID: ' + model.UID); // current Items InvoiceUID
         // Now run the payment records updates
         this.updatePayment(model);  // updates the payment record. //1
         this.toastr.info('Invoice Payments + Items Vrs Upgraded In SOP');
         // this.refreshGrid();
         this.getPayment(model.payment_id); // just tring to regresh comppoentent after create
       // set up a global redirect so that it refreshed if included on two levels down.
       if (this.subject_id_check >= 1) {
       // this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
       }

       },
       error => {
         // console.error('Error saving Event!');
         //  this.toastr.error('Error Updating Invoice Payment(s) to Myob Details');
         console.log(error.error);
        });

       };

}
